import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  getTemplateMaster as getTemplateMasterAPI,
  putTemplateMaster,
  postTemplateMaster,
  deleteTemplateMaster as deleteTemplateMasterAPI,
  TemplateMasterParams,
} from './api';
import {
  PostTemplateMaster,
  PutTemplateMaster,
  Status,
} from '../../services/apiTypes';

interface StatusState {
  status: Status;
}

const initialState: StatusState = {
  status: 'idle',
};

export const getTemplateMaster = createAsyncThunk(
  'template/getTemplateMaster',
  async (params: TemplateMasterParams | undefined, { rejectWithValue }) => {
    try {
      return await getTemplateMasterAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateTemplateMaster = createAsyncThunk(
  'template/updateTemplateMaster',
  async (newTemplate: PutTemplateMaster, { rejectWithValue }) => {
    try {
      return await putTemplateMaster(newTemplate);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createTemplateMaster = createAsyncThunk(
  'template/createTemplateMaster',
  async (newTemplate: PostTemplateMaster, { rejectWithValue }) => {
    try {
      return await postTemplateMaster(newTemplate);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteTemplateMaster = createAsyncThunk(
  'template/deleteTemplateMaster',
  async (params: TemplateMasterParams, { rejectWithValue }) => {
    try {
      return await deleteTemplateMasterAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const templateSlice = createSlice({
  name: 'template',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTemplateMaster.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getTemplateMaster.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(getTemplateMaster.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(updateTemplateMaster.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateTemplateMaster.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(updateTemplateMaster.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(createTemplateMaster.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(createTemplateMaster.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(createTemplateMaster.rejected, (state) => {
        state.status = 'failed';
      })
      .addCase(deleteTemplateMaster.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteTemplateMaster.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteTemplateMaster.rejected, (state) => {
        state.status = 'failed';
      });
  },
});

export default templateSlice.reducer;
